import React from "react";
import { useSelector } from "react-redux";

const ApplicationTracker = () => {
  const policyData = useSelector((state) => state.journey.policyStatusData);

  const baseSteps = [
    {
      title: "BI Generated",
      description:
        "Your benefit illustration based on the details has been created.",
      fixed: true,
    },
    {
      title: "Payment Done",
      description: "Your payment has been successfully processed.",
      fixed: true,
    },
    {
      title: "Auto Renewal",
      description: (<>Auto-renewal preference recorded:{" "} <span className="highlight-text">Enabled</span>.</>),
      fixed: true,
    },
    {
      title: "Proposal Form",
      description: "Proposal form has been completed.",
      fixed: true,
    },
    {
      title: "Documents Uploaded",
      description:
        "All required documents have been received.",
      fixed: true,
    },
    {
      title: "Pre-Issuance Verification Call",
      description:
        "A verification call has been conducted to confirm proposal details.",
      fixed: true,
    },

    {
      title: "Application Submitted",
      description:
        "Your details have been submitted and are currently being reviewed by our Business Ops team.",
      fixed:true,
    },
    {
      title: "Requirement Raised",
      description:
        "Your details will be reviewed by our Underwriting team.",
      key: "UW",
    },
    {
      title: "Final Status",
      description:
        "Your contract proposal has been finalized and is ready for the next step.",
      key: "PS",
    },
  ];

  const STATUS_INDEX_MAP = {
    UW: 7,
    PS:8,
  };

  const policyStatus = policyData;

  const steps = baseSteps.map((step, index) => {
    if (step.fixed) {
      return { ...step, status: "completed" };
    }

    const currentIndex = STATUS_INDEX_MAP[policyStatus];

    if (index < currentIndex) {
      return { ...step, status: "completed" };
    }

    if (index === currentIndex) {
      return { ...step, status: "current" };
    }

    return { ...step, status: "pending" };
  });

  const handleAllPlans = () => {
    window.location.href = "/all-plans";
  };

  return (
    <div className="proposal-content">
      <div className="proposal-tab-layout">
        {/* Top Section */}
        <div className="proposal-side">
          <div className="proposal-side__illustration">
            <svg
              width="166"
              height="150"
              viewBox="0 0 166 240"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.63749 84.66L6.45101 84.9997C4.4226 88.6984 6.29545 93.6261 10.6347 96.0054L20.3427 101.329C24.7914 103.769 30.0842 102.672 32.1642 98.8792C34.2438 95.0867 32.3234 90.0345 27.8746 87.5944L18.1664 82.2708C13.8274 79.8916 8.66558 80.9612 6.63749 84.66Z"
                fill="#FFB27D"
              />
              <path
                d="M146.741 217.641H82.5815L78.5024 199.026C71.7217 193.922 54.4839 178.338 47.4615 165.471C47.3358 165.242 47.2142 165.014 47.0963 164.787C47.0007 164.603 46.9068 164.421 46.8172 164.24C46.6076 163.823 46.4119 163.41 46.2264 163.001C44.6519 159.502 43.9894 156.285 44.6959 153.641C44.9513 152.675 45.3924 151.788 46.0369 150.989C47.5237 149.152 50.2016 144.364 53.0931 138.84C57.274 130.856 61.9017 121.328 64.0169 116.931C64.7554 115.395 65.1883 114.485 65.1883 114.485C65.1883 114.485 66.9064 111.415 69.5525 106.768C70.4823 105.136 71.5281 103.306 72.6516 101.346C74.5694 98.0094 76.7188 94.2938 78.9279 90.522C80.4046 88.0036 81.9093 85.4613 83.3879 82.9889C84.1624 81.6958 84.9305 80.4226 85.6827 79.1835C86.8341 77.2895 87.9517 75.4754 89.0134 73.7834C89.1352 73.5878 89.2568 73.3963 89.3787 73.2047C90.6657 71.1632 91.8631 69.3174 92.9227 67.7566C93.6692 66.6573 94.3476 65.6973 94.9404 64.9132C96.2831 63.1389 97.1873 62.2511 97.4625 62.616C98.0793 63.4341 101.673 65.9688 106.337 69.4052C106.618 69.6107 106.906 69.8224 107.195 70.0379C107.421 70.2055 107.65 70.373 107.879 70.5447C108.307 70.8619 108.738 71.1832 109.177 71.5125C118.228 78.3032 129.551 87.521 131.87 94.3698C136.855 109.095 139.353 171.377 138.302 176.379C137.661 179.426 142.702 201.126 146.741 217.641Z"
                fill="#FFB27D"
              />
              <path
                d="M43.7355 86.9025L43.9643 86.5099C46.4586 82.2361 45.0161 76.7492 40.7422 74.255L13.8198 58.543C9.43718 55.9854 3.81138 57.4647 1.25396 61.8472C-1.30362 66.2296 0.175662 71.8553 4.5581 74.413L31.4805 90.125C35.7542 92.6191 41.2409 91.1764 43.7355 86.9025Z"
                fill="#FFB27D"
              />
              <path
                d="M102.928 8.74604L115.124 149.738C115.525 154.37 112.096 158.45 107.465 158.85L33.7617 165.226C29.1298 165.627 25.0504 162.197 24.6499 157.565L12.4537 16.5724C12.0532 11.942 15.4828 7.86259 20.115 7.46193L93.8181 1.08651C98.4487 0.685847 102.528 4.1156 102.928 8.74604Z"
                fill="#F5F6F6"
              />
              <path
                d="M116.178 149.649L115.56 142.487V142.485L114.536 130.668L114.099 125.609L113.696 120.959L112.941 112.21V112.208L112.374 105.661L109.437 71.7123V71.7102L109.153 68.4159L108.384 59.5288L108.325 58.8412L107.165 45.4386L105.394 24.9752L104.858 18.7779L104.021 9.08867L103.983 8.65774C103.533 3.45256 98.9319 -0.414882 93.7289 0.0356981L49.2075 3.88737L46.686 4.10476L20.0249 6.4108C14.8198 6.86154 10.9523 11.462 11.4029 16.6654L15.0884 59.2856L16.4915 75.4886L17.0272 81.6918L17.0309 81.7314L17.5843 88.1361L18.6455 100.394L23.5977 157.659C24.0483 162.862 28.6488 166.731 33.8541 166.281L47.2665 165.121L57.8173 164.208L91.8275 161.265H91.8298L92.5468 161.204L92.5726 161.202L107.556 159.905C109.876 159.704 111.931 158.68 113.455 157.143C115.35 155.234 116.427 152.534 116.178 149.649ZM92.7919 159.06L56.8213 162.172L46.2607 163.087H46.2586L33.6703 164.176C29.6272 164.526 26.0522 161.52 25.7024 157.477L20.8686 101.596L19.7045 88.1364L19.2599 82.9945L19.2481 82.8622V82.8599L18.6118 75.489L17.3213 60.5886L13.5073 16.4839C13.1575 12.4406 16.1631 8.86564 20.2066 8.51603L46.5727 6.2356L49.0944 6.01803H49.0965L93.9105 2.14093C97.9536 1.79116 101.529 4.7969 101.878 8.8402L101.9 9.08932L103.289 25.14L104.054 33.9892L105.137 46.5261L106.277 59.7053L106.337 60.401L107.046 68.5903L107.171 70.0229V70.0253L110.168 104.68L110.716 111.015L111.915 124.89L112.67 133.611L113.315 141.063L113.455 142.682L114.073 149.833C114.186 151.126 113.955 152.371 113.455 153.477C112.394 155.831 110.123 157.56 107.374 157.799L92.7919 159.06Z"
                fill="#3C3D3D"
              />
              <path
                d="M98.0257 75.1834L29.3355 81.2029C28.1319 81.3077 27.059 80.4103 26.9541 79.2051L22.0789 23.5556C21.9722 22.352 22.8714 21.281 24.0748 21.1743L45.8881 19.2633L48.4116 19.0419L55.755 18.3997L57.3005 18.2633L58.8775 18.125L59.5118 18.0696L92.765 15.1567C93.9686 15.0521 95.0396 15.9492 95.1464 17.1525L98.9269 60.3144L98.9588 60.6679L99.4604 66.3872L99.7057 69.1992L100.022 72.8039C100.126 74.0076 99.2292 75.0788 98.0257 75.1834Z"
                fill="#D4E5D8"
              />
              <g opacity="0.5">
                <path
                  d="M103.693 150.529L36.5117 156.416C35.3347 156.518 34.2852 155.641 34.1828 154.462L29.4147 100.035C29.3103 98.8578 30.1897 97.8099 31.3667 97.7059L52.7007 95.8367L55.1685 95.6203L62.3511 94.9922L63.8621 94.8589L65.4047 94.7238L66.0251 94.6697L98.5479 91.8206C99.7247 91.7182 100.772 92.5957 100.877 93.7725L104.574 135.986L104.605 136.332L105.096 141.926L105.335 144.676L105.645 148.202C105.748 149.379 104.87 150.426 103.693 150.529Z"
                  fill="#D0D1D1"
                />
              </g>
              <path
                d="M96.2301 182.936C96.1825 182.936 96.134 182.927 96.0878 182.906C95.9926 182.864 93.7399 181.839 92.1163 178.515C89.4475 173.049 90.6085 165.657 92.0525 160.42C92.1044 160.232 92.2988 160.121 92.4867 160.173C92.6749 160.225 92.7853 160.419 92.7336 160.607C87.863 178.274 96.2875 182.222 96.3731 182.26C96.5516 182.339 96.6322 182.547 96.5535 182.726C96.4949 182.858 96.3656 182.936 96.2301 182.936Z"
                fill="#E8945B"
              />
              <path
                d="M43.0698 49.1127C42.2601 39.4008 49.477 30.8715 59.1889 30.062C68.9007 29.2524 77.4298 36.4691 78.2397 46.1811C79.0494 55.893 71.8323 64.4221 62.1204 65.2318C52.4086 66.041 43.8793 58.8247 43.0698 49.1127Z"
                fill="#03BF43"
              />
              <path
                d="M60.2004 57.1039C59.4976 57.1039 58.8206 56.8125 58.3364 56.291L50.4841 47.8315C49.5283 46.8017 49.5882 45.1921 50.6179 44.2367C51.6477 43.2804 53.2571 43.3408 54.2127 44.3703L59.6598 50.2387L65.9379 38.725C66.6106 37.4915 68.1557 37.0369 69.3888 37.7092C70.6222 38.3819 71.0769 39.9268 70.4043 41.1601L62.4338 55.778C62.042 56.4964 61.3286 56.9824 60.5163 57.084C60.4108 57.0973 60.3052 57.1039 60.2004 57.1039Z"
                fill="white"
              />
              <g opacity="0.5">
                <path
                  d="M54.5676 92.8217L31.2442 94.8122C29.9444 94.923 28.7905 93.9507 28.6795 92.651L28.1024 85.8881C27.9916 84.5884 28.9641 83.4344 30.2635 83.3234L53.5873 81.3328C54.8867 81.2219 56.0409 82.1945 56.1517 83.4941L56.7288 90.2572C56.8398 91.5567 55.8671 92.7107 54.5676 92.8217Z"
                  fill="#D0D1D1"
                />
              </g>
              <g opacity="0.5">
                <path
                  d="M98.4051 89.0813L63.289 92.0783C61.7194 92.2123 60.325 91.0375 60.1912 89.4674L59.6979 83.6873C59.5639 82.1171 60.7385 80.7233 62.3085 80.5893L97.4247 77.5924C98.9945 77.4585 100.388 78.6334 100.522 80.2032L101.016 85.9836C101.15 87.5533 99.9752 88.9473 98.4051 89.0813Z"
                  fill="#D0D1D1"
                />
              </g>
              <path
                d="M124.532 111.024C124.532 111.024 96.7665 98.8958 79.8366 90.7939C78.6315 90.2171 72.9838 89.7488 69.5475 89.5605C56.4649 88.8441 46.1653 89.0568 46.0719 90.1696C44.9556 103.462 67.168 105.229 70.756 107.257C84.2288 114.874 104.458 132.075 101.037 139.521C99.7822 142.253 97.7952 144.959 96.8227 147.21C88.1856 167.207 91.9689 169.34 113.807 177.376C132.448 184.236 136.848 161.237 136.848 161.237L130.569 141.384L124.532 111.024Z"
                fill="#FFB27D"
              />
              <path
                d="M165.548 237.995C150.827 238.224 136.3 238.528 122.348 238.852C122.085 238.858 121.821 238.864 121.558 238.87C119.102 238.928 116.665 238.987 114.246 239.044C113.981 239.05 113.718 239.056 113.456 239.062C109.477 239.159 105.555 239.255 101.697 239.35C97.8869 239.443 94.1402 239.536 90.4663 239.627C90.2016 239.633 89.9391 239.638 89.6759 239.647C84.8916 239.761 80.2339 239.876 75.7204 239.981C75.4553 239.986 75.1925 239.992 74.9297 239.998V222.147C77.1333 219.839 79.5659 217.707 82.1607 215.741C85.9428 212.873 90.069 210.356 94.3397 208.15C100.62 204.903 107.209 202.33 113.456 200.309C116.244 199.403 118.963 198.609 121.558 197.913C130.196 195.597 137.442 194.368 141.165 193.825C142.891 193.572 143.861 193.465 143.861 193.465L165.548 237.995Z"
                fill="#CF3339"
              />
            </svg>
          </div>
          <h3 className="proposal-side__heading">Track Your Application</h3>
          <p className="proposal-side__subtext">
            Stay informed at every step of your policy journey. Check the
            current status of your application and know exactly what's happening
            behind the scenes.
          </p>
        </div>
        <div className="proposal-tab-main">
          <div className="proposal-section track-section">
            <ul className="proposal-section__steps">
              {steps.map((step, index) => (
                <li
                  key={index}
                  className={`proposal-section__step ${step.status === "completed" ? "completed" : "current"}`}
                >
                  <div className="proposal-section__step-dot">
                    <div
                      className={`dot ${step.status === "completed" ? "completed" : "active-dot"}`}
                    >
                      {step.status === "completed" ? (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="12" cy="12" r="12" fill="#03BF43" />
                          <path
                            d="M16.3592 8.3934C16.1837 8.21783 15.8993 8.21783 15.7242 8.3934L9.75396 14.3637L8.27449 12.8852C8.09943 12.7096 7.81453 12.7096 7.63948 12.8852C7.46392 13.0607 7.46392 13.3452 7.63948 13.5202L9.38025 15.261C9.42646 15.3072 9.48086 15.3395 9.53835 15.3616C9.60972 15.4052 9.68723 15.4345 9.76782 15.4345C9.8828 15.4345 9.9978 15.3908 10.0856 15.3031L16.3592 9.02892C16.5348 8.85337 16.5348 8.56897 16.3592 8.39341V8.3934H16.3592Z"
                            fill="white"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="12" cy="12" r="12" fill="#FCE4E5" />
                          <circle cx="11.9961" cy="12" r="8" fill="#F6ABAE" />
                          <circle cx="11.9961" cy="12" r="5" fill="#97262A" />
                        </svg>
                      )}
                    </div>
                  </div>

                  <div className="proposal-section__step-info">
                    <strong>{step.title}</strong>
                    <span>{step.description}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <p className="bootom-text">
            Your application goes through multiple verification stages to ensure
            accuracy and compliance. Some steps may take time depending on
            document review or regulatory checks.If any action is needed from your side,we'll
            notify you promptly so your application can move forward without delays.
            You can revisit this page anytime to stay updated and complete pending steps,if any. 
          </p>
        </div>
      </div>
      <div className="proposal-form-actions">
        <button
          onClick={handleAllPlans}
          className="proposal-btn-continue proposal-btn-continue btn primary-button regular"
        >
          Explore Other Plans
        </button>
      </div>
    </div>
  );
};

export default ApplicationTracker;
